import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

interface PieChartProps {
  title: string;
  labels: string[];
  data: number[];
  backgroundColor?: string[];
  borderColor?: string[];
  compact?: boolean;
}

const PieChart: React.FC<PieChartProps> = ({ 
  title, 
  labels, 
  data, 
  compact = false,
  backgroundColor = [
    '#FF6384',
    '#36A2EB',
    '#FFCE56',
    '#4BC0C0',
    '#9966FF',
    '#FF9F40',
    '#FF6384',
    '#C9CBCF',
    '#4BC0C0',
    '#FF6384'
  ],
  borderColor = '#fff'
}) => {
  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor,
        borderColor,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: compact
          ? { boxWidth: 10, font: { size: 10 } }
          : undefined,
      },
    },
  };

  return (
    <div className={compact ? 'h-40' : 'h-64'}>
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default PieChart;
